












import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class Popover extends Vue {
  visible = false;
  @Prop({
    type: String,
    default: 'top',
    validator(value: string): boolean {
      return ['top', 'bottom', 'left', 'right'].indexOf(value) >= 0;
    }
  }) position!: string;

  @Prop({
    type: String,
    default: 'click',
    validator(value: string): boolean {
      return ['click', 'hover'].indexOf(value) >= 0;
    }
  }) trigger!: string;

  mounted() {
    if (this.trigger === 'click') {
      this.$refs.popover.addEventListener('click', this.onClick);
    } else {
      this.$refs.popover.addEventListener('mouseenter', this.open);
      this.$refs.popover.addEventListener('mouseleave', this.close);
    }
  }

  $destroy() {
    if (this.trigger === 'click') {
      this.$refs.popover.removeEventListener('click', this.onClick);
    } else {
      this.$refs.popover.removeEventListener('mouseenter', this.open);
      this.$refs.popover.removeEventListener('mouseleave', this.close);
    }
  }

  positionContent() {
    const {contentWrapper, triggerWrapper} = this.$refs;
    document.body.appendChild(contentWrapper);
    const {left, top, height, width} = triggerWrapper.getBoundingClientRect();
    const {height: height2} = contentWrapper.getBoundingClientRect();

    const positions = {
      top: {left: left + window.scrollX, top: top + window.scrollY},
      bottom: {left: left + window.scrollX, top: top + height + window.scrollY},
      left: {left: left + window.scrollX, top: top + window.scrollY + (height - height2) / 2},
      right: {left: left + width + window.scrollX, top: top + window.scrollY + (height - height2) / 2},
    };

    contentWrapper.style.left = positions[this.position].left + 'px';
    contentWrapper.style.top = positions[this.position].top + 'px';
  }

  onClickDocument(e: object) {
    if (this.$refs.popover &&
      (this.$refs.popover === e.target || this.$refs.popover.contains(e.target))
    ) {return;}
    if (this.$refs.contentWrapper &&
      (this.$refs.contentWrapper === e.target || this.$refs.contentWrapper.contains(e.target))
    ) {return;}
    this.close();
  }

  open() {
    this.visible = true;
    setTimeout(() => {
      this.positionContent();
      document.addEventListener('click', this.onClickDocument);
    }, 0);
  }

  close() {
    this.visible = false;
    document.removeEventListener('click', this.onClickDocument);
  }

  onClick(event: object) {
    if (this.$refs.triggerWrapper.contains(event.target)) {
      if (this.visible) {
        this.close();
      } else {
        this.open();
      }
    }
  }

}
